/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ecg-toasts[_ngcontent-%COMP%]{margin-top:4.8rem}"];
export { styles as styles };
